var app = angular.module("leonardo");

var UserStates = function($stateProvider) {
  $stateProvider.state('users', {
    url: '/users',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'users.overview',
    ncyBreadcrumb: {
      label: 'Users'
    }
  });

  $stateProvider.state('users.overview', {
    url: "/overview",
    title: 'Users',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/account-user/list.html',
        controller: 'AccountUserList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/user-list.html',
        controller: 'UserListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'UserListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'User List'
    }
  });

  $stateProvider.state('users.roles', {
    url: "/roles",
    title: 'User Roles',
    only_filter_account:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/account-user/roles.html'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/user-roles.html'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'UserRolesListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Roles List'
    }
  });

  $stateProvider.state('users.roles.add', {
    url: "/add",
    title: 'Add Role',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/account-user/form-role.html'
      },
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {}
    },
    ncyBreadcrumb: {
      label: 'Add Role'
    }
  });

  $stateProvider.state('users.add-admin', {
    url: "/add-admin",
    title: 'Add new system admin',
    system: true,
    action: 'create',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/account-user/form.html',
      }
    },
    ncyBreadcrumb: {
      label: 'Add new system admin',
    }
  });

  $stateProvider.state('users.add', {
    url: "/add",
    title: 'Add new user',
    action:'create',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/account-user/form.html'
      },
    },
    ncyBreadcrumb: {
      label: 'Add new user'
    }
  });
};

app.config(['$stateProvider', UserStates]);
